import React from 'react';

import {useState, useEffect, useCallback, useRef} from 'react'
import Marker from './Marker';
import MarkerCurrent from './MarkerCurrent';
import MapControler from './MapControler'
import MarkerSight from './MarkerSight';



/*
https://dev.to/talorlanczyk/how-to-integrate-google-maps-places-with-reactjs-37jd

https://developers.google.com/maps/documentation/javascript/places-autocomplete
*/
const mapContainerStyle = {
    height: "100vh",
    width: "100vw"
};


const options = {
    disableDefaultUI: true,
    zoomControl: true,
  };

const zoomSelected = 20; 
const zoomStart = 15; 

const markerStoreIcon = "https://res.cloudinary.com/wikimenu/image/upload/v1619810917/screenshots/map/marker_store_aksevt.png"
const markerSelectedIcon ="https://res.cloudinary.com/wikimenu/image/upload/v1619810915/screenshots/map/marker_selected_yzjq0z.png"


const markerSearching = "https://res.cloudinary.com/wikimenu/image/upload/v1691077077/screenshots/map/location-searching_dtu100.png"



export default function MapView(props) {
  const {     
    current, 
    pointer,
    action,
    mapStyle, 
    onSightChange
    } = props;
    
    
  const googleMap = useRef();
  const googleMapRef = useRef();
  const [status, setStatus] = useState("loading")
  const sight = useRef();

  const appGoogleMapStyle = mapStyle ? mapStyle: mapContainerStyle;  
  //console.debug("MapView");   

  useEffect(() => {
    //console.debug("useEffect currentPosition",pointer);
    if(!googleMap.current)
        createGoogleMap(pointer);
  }, []);

  
  const createGoogleMap =  (pointer) => {
  const centerPosition  =  pointer.geopoint; 
    
    if(!centerPosition){
      //console.debug("createGoogleMap");   
      googleMap.current = new window.google.maps.Map(googleMapRef.current, {
        zoom: zoomStart,
        disableDefaultUI: true,
      });  
      return;
    }
  
    //console.debug("createGoogleMap, pointer", pointer);   
    const center = geopointToMap(centerPosition)
    googleMap.current = new window.google.maps.Map(googleMapRef.current, {
      zoom: zoomStart,
      center: center,
      disableDefaultUI: true,
    });
    setStatus("created");
  };

  const geopointToMap = (geopoint)=>{
    return new window.google.maps.LatLng( geopoint.latitude,   geopoint.longitude);
  }

  const handlerCenterChanges = (sight)=>{
     if(onSightChange){
       onSightChange(sight)
     }
  }
  
  return (
    <div>
      {
       googleMap.current  && action && 
        <MapControler
          action = {action}
          googleMap= {googleMap}
        /> 
      }
      {
      googleMap.current  && 
        <MarkerSight
          googleMap= {googleMap}
          onUpdateCenter = { handlerCenterChanges}
          show = {pointer.marker=="sight"}
        /> 
      }

      {
        googleMap.current && 
        <Marker
          geopoint = {pointer.geopoint}
          googleMap={googleMap}
          show = {pointer.marker=="place"}
        /> 
      }

      {
      <div
        id="google-map"
        ref={googleMapRef}
        style={appGoogleMapStyle}
      />
      }
     
    </div>
  );
    

}


